<template>
  <md-field>
    <gl-icon-calendar />
    <md-input
      v-model="_value"
      type="date"
      :min="_min"
      :max="_max"
      :required="required"
      v-on="$listeners"
    />
  </md-field>
</template>

<script>
import moment from 'moment'

/**
 * 日付選択
 */
export default {
  props: {
    value: {
      type: String,
    },
    min: {
      type: String,
    },
    max: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _min() {
      if (!this.min) {
        return undefined
      }
      return moment(this.min, 'YYYYMMDD').format('YYYY-MM-DD')
    },
    _max() {
      if (!this.max) {
        return undefined
      }
      return moment(this.max, 'YYYYMMDD').format('YYYY-MM-DD')
    },
    _value: {
      get() {
        if (!this.value) {
          return undefined
        }
        return moment(this.value, 'YYYYMMDD').format('YYYY-MM-DD')
      },
      set(newVal) {
        if (!newVal) {
          this.$emit('update:value', undefined)
        } else {
          this.$emit(
            'update:value',
            moment(newVal, 'YYYY-MM-DD').format('YYYYMMDD'),
          )
        }
      },
    },
  },
}
</script>
